import { IPremiumConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IPremiumConfig';
import React from 'react';
import { ViewerTemplate } from '../ViewerTemplate';
import { Grid } from '../../../../../ui-toolkit/components';
import { RateConfigurationViewer } from './RateConfigurationViewer';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { RateConfigSelectorViewer } from './RateConfigSelectorViewer';
import { GrayCard } from '../shared/GrayCard';

export const PremiumsViewer: React.FC<{ premiumConfig: IPremiumConfigData }> = ({ premiumConfig }) => (
  <ViewerTemplate viewerName={'Premiums:'}>
    <Grid>
      <GrayCard isCollapsible title={'Basic Info'}>
        <LabelValueViewer label={'Amount Rounding'} value={premiumConfig.amountRounding} />
        <LabelValueViewer label={'Premium Rounding'} value={premiumConfig.premiumRounding} />
        {premiumConfig.simultaneousIssuePremium !== undefined && (
          <LabelValueViewer label={'Simultaneous Issue Premium'} value={premiumConfig.simultaneousIssuePremium} />
        )}
      </GrayCard>
      {premiumConfig.basicLenderRate && <RateConfigurationViewer rateConfiguration={premiumConfig.basicLenderRate} />}
      <GrayCard isCollapsible title={'Rates'}>
        <RateConfigSelectorViewer rates={premiumConfig.rates} />
      </GrayCard>
    </Grid>
  </ViewerTemplate>
);
